import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home'
  },
  {
    path: 'home',
    loadChildren: () => import('@health-house/features/home').then(m => m.healthHouseFeaturesHomeRoutes)
  },
  {
    path: 'cast',
    loadChildren: () => import('@health-house/features/cast').then(m => m.healthHouseFeaturesCastRoutes)
  }
];
